var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "-30 -30 160 160",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\u5716\\u5C64_1",
    style: {
      height: "100%",
      width: "100%",
      background: "rgb(241, 242, 243)",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(1, 1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(1)",
      transformOrigin: "50.0002px 50px",
      animation: "2s linear 0s infinite alternate forwards running breath-2b70fd7e-423a-48ab-a5d2-698155ad6ce5"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M27.378 92.5c-5.288 0-9.792-2.668-12.048-7.138-3.657-7.246-.386-16.816 7.446-21.787 2.617-1.661 5.486-2.62 8.354-2.8V27c0-3.22 2.071-6.01 5.154-6.941L76.816 7.81a7.24 7.24 0 0 1 2.098-.31 7.3 7.3 0 0 1 4.323 1.43 7.278 7.278 0 0 1 2.928 5.821V62.37c0 .285-.034.563-.097.828.162 6.045-3.306 12.289-8.911 15.847-2.919 1.852-6.15 2.831-9.344 2.831-5.288 0-9.792-2.669-12.048-7.139-3.656-7.246-.386-16.815 7.446-21.786 2.646-1.68 5.551-2.641 8.452-2.805V37.363l-26.029 7.832v28.381c0 .05-.001.098-.003.148.208 6.132-3.258 12.358-8.908 15.944-2.92 1.853-6.151 2.832-9.345 2.832z",
    style: {
      fill: "rgb(255, 213, 150)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M82.626 14.752a3.71 3.71 0 0 0-4.787-3.554L37.308 23.446A3.712 3.712 0 0 0 34.669 27v37.568c-3.081-.717-6.694-.103-9.997 1.994-6.218 3.946-8.987 11.65-6.183 17.205 2.804 5.556 10.119 6.861 16.337 2.914 4.789-3.04 7.528-8.306 7.255-13.104h.013V42.565L75.2 32.603V53.97c-3.103-.753-6.756-.15-10.094 1.968-6.217 3.946-8.986 11.649-6.183 17.204 2.804 5.556 10.119 6.861 16.337 2.914 4.984-3.163 7.748-8.737 7.207-13.687h.159V14.752z",
    style: {
      fill: "rgb(255, 87, 1)"
    }
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "breath-2b70fd7e-423a-48ab-a5d2-698155ad6ce5",
    "data-anikit": ""
  }, "@keyframes breath-2b70fd7e-423a-48ab-a5d2-698155ad6ce5\n{\n  0% {\n    animation-timing-function: cubic-bezier(0.9647,0.2413,-0.0705,0.7911);\n    transform: scale(0.9099999999999999);\n  }\n  51% {\n    animation-timing-function: cubic-bezier(0.9226,0.2631,-0.0308,0.7628);\n    transform: scale(1.02994);\n  }\n  100% {\n    transform: scale(0.9099999999999999);\n  }\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicOn);
export default __webpack_public_path__ + "static/media/music-on.f7d7efb9161aa0ac192c695781c61b74.svg";
export { ForwardRef as ReactComponent };